module.exports = __webpack_public_path__ + "static/PKB-83442d2598f8655bf937f69ad6ab4552.png";